// 📁 src/socket.js
import { io } from 'socket.io-client';

// Make sure this matches your backend HTTPS + port
const socket = io('https://beatautomation.com:3001', {
  withCredentials: true,
  transports: ['websocket'],  // Helps with HTTPS + Nginx
  
});

export default socket;


